'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_CAPTURE_RESPONSE_EMAIL = exports.QUICK_REPLY = exports.ALLOW_USER_INPUT = exports.URL = exports.TEXT = exports.RICH_TEXT = exports.ID = exports.MESSAGE_DELETE_STATUS = exports.TIMESTAMP = exports.THREAD_ID = exports.SENDER_TYPE = exports.SENDER_ID = exports.LIVE_CHAT_ATTACHMENTS = exports.METADATA_AUDIT_TIMESTAMP = exports.METADATA_TYPE = exports.METADATA_SENT_OUTSIDE_OFFICE_HOURS = exports.METADATA_SENT_IN_AWAY_MODE = exports.METADATA_AGENT_ID = exports.METADATA = exports.DESCRIPTOR_USE = exports.DESCRIPTOR_TIMETOKEN = exports.DESCRIPTOR_STATUS = exports.DESCRIPTOR_SOURCE = exports.DESCRIPTOR_CHANNEL = exports.DESCRIPTOR = exports.CLIENT_TS = exports.MESSAGE_TYPE = undefined;

var _messageTypes = require('./messageTypes');

var MESSAGE_TYPE = exports.MESSAGE_TYPE = '@type';
var CLIENT_TS = exports.CLIENT_TS = ['clientTs'];
var DESCRIPTOR = exports.DESCRIPTOR = ['descriptor'];
var DESCRIPTOR_CHANNEL = exports.DESCRIPTOR_CHANNEL = ['descriptor', 'channel'];
var DESCRIPTOR_SOURCE = exports.DESCRIPTOR_SOURCE = ['descriptor', 'source'];
var DESCRIPTOR_STATUS = exports.DESCRIPTOR_STATUS = ['descriptor', 'status'];
var DESCRIPTOR_TIMETOKEN = exports.DESCRIPTOR_TIMETOKEN = ['descriptor', 'timetoken'];
var DESCRIPTOR_USE = exports.DESCRIPTOR_USE = ['descriptor', 'use'];
var METADATA = exports.METADATA = ['metadata'];
var METADATA_AGENT_ID = exports.METADATA_AGENT_ID = ['metadata', 'agentId'];
var METADATA_SENT_IN_AWAY_MODE = exports.METADATA_SENT_IN_AWAY_MODE = ['metadata', 'sentInAwayMode'];
var METADATA_SENT_OUTSIDE_OFFICE_HOURS = exports.METADATA_SENT_OUTSIDE_OFFICE_HOURS = ['metadata', 'sentOutsideOfficeHours'];
var METADATA_TYPE = exports.METADATA_TYPE = ['metadata', _messageTypes.MESSAGE_TYPE_ID];
var METADATA_AUDIT_TIMESTAMP = exports.METADATA_AUDIT_TIMESTAMP = ['metadata', 'auditTimestamp'];
var LIVE_CHAT_ATTACHMENTS = exports.LIVE_CHAT_ATTACHMENTS = ['metadata', 'attachments'];
var SENDER_ID = exports.SENDER_ID = ['senderId'];
var SENDER_TYPE = exports.SENDER_TYPE = ['senderType'];
var THREAD_ID = exports.THREAD_ID = ['threadId'];
var TIMESTAMP = exports.TIMESTAMP = ['timestamp'];
var MESSAGE_DELETE_STATUS = exports.MESSAGE_DELETE_STATUS = ['messageDeletedStatus'];
var ID = exports.ID = ['id'];
var RICH_TEXT = exports.RICH_TEXT = ['metadata', 'richText'];
var TEXT = exports.TEXT = ['metadata', 'text'];
var URL = exports.URL = ['metadata', 'url'];
var ALLOW_USER_INPUT = exports.ALLOW_USER_INPUT = ['metadata', 'quickReply', 'allowUserInput'];
var QUICK_REPLY = exports.QUICK_REPLY = ['metadata', 'quickReply'];
var EMAIL_CAPTURE_RESPONSE_EMAIL = exports.EMAIL_CAPTURE_RESPONSE_EMAIL = ['metadata', 'email'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/constants/keyPaths.js
// module id = 43
// module chunks = 2 3